module.exports = __webpack_public_path__ + "img/Capture-519.d8d94df6.jpg";